import getApiClient from '@/plugins/api'
import moment from "moment/moment";

export default {
  loadItem() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id

    self.$store.commit('startLoading')

    api.get(`categories/${itemId}`, {
      params: self.searchParams
    })
      .then((result) => {
        self.category = result.data
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  save() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id

    let method = 'post',
      endpoint = 'categories',
      headers = {}

    if (itemId) {
      method = 'patch'
      endpoint = `categories/${itemId}`
      headers['Content-Type'] = 'application/merge-patch+json'
    }

    self.success = false
    self.error = false
    self.errors = {}
    self.$store.commit('startLoading')
    api[method](endpoint, self.category, {headers: headers})
      .then(response => {
        self.category = response.data
        self.success = true
      })
      .catch(error => {
        self.error = true
        self.processErrors(error.response.data.violations)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  processErrors(errors) {
    const self = this
    self.errors = {}

    errors.forEach(error => {
      self.errors[error.propertyPath] = error.message
    })
  }
}
